import { TargetPlatforms } from './TargetPlatforms';
import { isKeyOfObject } from '../types';
export function getTargetById(id) {
    var key = id && id.toUpperCase().replace(/-/g, '_');
    if (key === 'JS_IR') {
        console.warn('JS_IR is deprecated, use JS + compiler-version instead');
        key = 'JS';
    }
    return isKeyOfObject(key, TargetPlatforms) ? TargetPlatforms[key] : null;
}
export function isJavaRelated(platform) {
    return (platform === TargetPlatforms.JAVA || platform === TargetPlatforms.JUNIT);
}
export function isJsRelated(platform) {
    return (platform === TargetPlatforms.JS ||
        platform === TargetPlatforms.CANVAS ||
        platform === TargetPlatforms.SWIFT_EXPORT);
}
export function isWasmRelated(platform) {
    return (platform === TargetPlatforms.WASM ||
        platform === TargetPlatforms.COMPOSE_WASM);
}
var MINIMAL_VERSION_IR = '1.5.0';
export function isJsLegacy(platform, compilerVersion) {
    return isJsRelated(platform) && compilerVersion < MINIMAL_VERSION_IR;
}
export * from './TargetPlatforms';
